import { userService } from './userService';
import { syncService } from './syncService';
import { Form, useNavigate, useOutletContext, useLoaderData, useSearchParams } from "react-router";
import React, { useState, useEffect } from 'react'
import { Button, Field, Fieldset, Input, Label } from '@headlessui/react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';


let navigate = {};
let msalInstance = {};

export async function loginLoader({ }) {
  return {};
}

export function Login({ }) {

  const [searchParams, setSearchParams] = useSearchParams();
  const { activeAccount, instance } = useOutletContext();
  const [show, setShow] = useState(false);
  const [showLoginFailed, setShowLoginFailed] = useState("false");
  const [sales, setSales] = useState(false);
  const [loadComplete, setLoadComplete] = useState(false);

  navigate = useNavigate();

  useEffect(() => {
    msalInstance = instance;
    const syncData = async () => {
      await syncService.syncMasterData(activeAccount.idToken);
      setSales(await isSalesUser(activeAccount));
      setLoadComplete(true);
    };
    let param = searchParams.get("failed");
    setShowLoginFailed(param);
    syncData();
    console.log(`Is sales : ${sales}`)

  }, [searchParams]);

  useEffect(() => {
    if (sales) {
      (async () => {
        await userService.createSalesSession(activeAccount);
        navigate("/sales", { replace: true });
      })();
    }
  }, [sales]);

  return (
    <>
      {loadComplete &&
        <>
          <div className="">
            <div className="top-0 left-0 p-6">
              <img
                alt="PVS"
                src="/logo.svg"
                className="h-8"
              />
            </div>
            <div className="absolute top-0 right-0 p-6">
              <img
                alt="Yellow"
                src="/yellow.svg"
                className="h-8"
              />
            </div>
          </div>

          <div className="">
            <h1 className="text-6xl font-inter font-bold pt-15 p-6">Device activated! </h1>
            <h1 className="text-lg font-inter pt-10 pl-6 pr-6">User Login</h1>
            <Form action="/login" method="post" className="mx-6">
              <Fieldset>
                <Field >
                  <Input name="username" type="text" className="bg-white rounded-md p-2 py-4 text-gray-800 min-w-full m-2" placeholder='username' />
                  <div className="relative min-w-full">
                    <Input name="password" type={show ? 'text' : 'password'} className="bg-white rounded-md p-2 py-4 text-gray-800 w-full m-2" placeholder='password'></Input>
                    <Button onClick={() => setShow(!show)} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-800 hover:text-gray-700">
                      {show ? (
                        <EyeSlashIcon className="w-5 h-5" />
                      ) : (
                        <EyeIcon className="w-5 h-5" />
                      )}
                    </Button>
                  </div>
                </Field>
              </Fieldset>
              <Button type="submit" className="w-full bg-pvs-gray block rounded p-3.5 items-center justify-center text-white m-2">Login</Button>

              {showLoginFailed === "true" &&
                <div className="text-pvs-red text-center">Username or password incorrect, please try again.</div>
              }

              <div className="absolute w-full top-4/5 flex items-center justify-center pr-8">
                <Button onClick={async () => await resetDevice(activeAccount.idToken)} className="w-full bg-pvs-gray block rounded p-3.5 items-center justify-center text-white m-2 w-full">Reset Device</Button>
              </div>

            </Form>
          </div>
        </>
      }

    </>
  );

}

export async function callLogin(request) {
  let formData = await request.formData();
  let user = await userService.login(formData.get("username"), formData.get("password"))

  if (user == null) {
    navigate("/login?failed=true", { replace: true });
  }
  else {
    navigate("/welcome", { replace: true });
  }
}

async function resetDevice(token) {
  await syncService.resetMasterDataDb();
  userService.clearCaches();
  msalInstance.logoutRedirect({
    postLogoutRedirectUri: "/",
  });
  window.location.reload();
}

async function isSalesUser(activeAccount) {
  return await userService.isSalesUser(activeAccount);
}


